import api from "./api";

const ratingService = {
  // Get ratings for a specific product
  getProductRatings: async (productId, filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.rating) params.append("rating", filters.rating);
      if (filters.verified_only) params.append("verified_only", filters.verified_only);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);
      if (filters.limit) params.append("limit", filters.limit);
      if (filters.offset) params.append("offset", filters.offset);

      const response = await api.get(
        `/api/ratings/products/${productId}/ratings?${params.toString()}`
      );
      // Response format: { success: true, data: { ratings: [...], summary: {...} } }
      return response.data?.data || response.data || { ratings: [], summary: null };
    } catch (error) {
      console.error("Error fetching product ratings:", error);
      // Return empty data instead of throwing to prevent breaking the UI
      return { ratings: [], summary: null };
    }
  },

  // Get customer's rating for a specific product
  getCustomerRating: async (productId) => {
    try {
      const response = await api.get(
        `/api/ratings/products/${productId}/my-rating`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching customer rating:", error);
      throw error;
    }
  },

  // Get ratings for multiple products (for order items)
  getRatingsForProducts: async (productIds, orderId = null) => {
    try {
      // Fetch ratings for each product
      const ratingPromises = productIds.map(async (productId) => {
        try {
          const response = await api.get(
            `/api/ratings/products/${productId}/ratings`
          );
          const ratings = response.data?.data?.ratings || [];
          
          // If orderId is provided, filter ratings by order_id
          if (orderId) {
            return ratings.filter(rating => rating.order_id === orderId);
          }
          return ratings;
        } catch (error) {
          console.error(`Error fetching ratings for product ${productId}:`, error);
          return [];
        }
      });

      const results = await Promise.all(ratingPromises);
      
      // Create a map of product_id -> ratings
      const ratingsMap = {};
      productIds.forEach((productId, index) => {
        ratingsMap[productId] = results[index] || [];
      });

      return ratingsMap;
    } catch (error) {
      console.error("Error fetching ratings for products:", error);
      throw error;
    }
  },

  // Get all ratings (admin)
  getAllRatings: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.product_id) params.append("product_id", filters.product_id);
      if (filters.customer_id) params.append("customer_id", filters.customer_id);
      if (filters.rating) params.append("rating", filters.rating);
      if (filters.is_approved !== undefined) params.append("is_approved", filters.is_approved);
      if (filters.is_verified_purchase !== undefined) params.append("is_verified_purchase", filters.is_verified_purchase);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);
      if (filters.limit) params.append("limit", filters.limit);
      if (filters.offset) params.append("offset", filters.offset);

      const response = await api.get(
        `/api/ratings/admin/all?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching all ratings:", error);
      throw error;
    }
  },

  // Delete rating (admin/vendor)
  deleteRatingAdmin: async (ratingId) => {
    try {
      const response = await api.delete(`/api/ratings/admin/${ratingId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting rating:", error);
      throw error;
    }
  },
};

export default ratingService;

